import { render, staticRenderFns } from "./requestInfo.vue?vue&type=template&id=05d1a3f0&scoped=true&"
import script from "./requestInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./requestInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./requestInfo.vue?vue&type=style&index=0&id=05d1a3f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1a3f0",
  null
  
)

export default component.exports